import SocialAuth from './SocialAuth'

export default SocialAuth
